module.exports = __webpack_public_path__ + "static/media/tictac.bc6a9cac.png";